import React from 'react';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import { useQuery } from '@tanstack/react-query';


GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker');


export const usePDFDocument = (pdfFile?: File | string) => {
  const pdfUrl = React.useMemo(() => {
    if (typeof pdfFile === 'string') {
      return pdfFile;
    } else if (pdfFile instanceof File) {
      const blob = new Blob([ pdfFile ], { type: 'application/pdf' });

      return URL.createObjectURL(blob);
    }

    return;
  }, [ pdfFile ]);

  return useQuery([ 'pdf', pdfUrl ], async () => {
    if (!pdfUrl) {
      return null;
    }

    const pdf = await getDocument(pdfUrl).promise;

    return pdf;
  });
};

